module.exports = __webpack_public_path__ + "img/chat-with-doc.13cb704e.jpg";